import React, { useState } from 'react'
import { LayoutGrid, Plus, Trash2 } from 'lucide-react'
import { Button, EmptyState, IconButton } from '../../components/ui'
import { InlineConfirm, NO_COURT_STYLE, Swatch } from './shared'

function CourtsTab({ courts, courtName, setCourtName, onAdd, onRemove, courtStyle }) {
  const [asking, setAsking] = useState(null)

  const confirmRemove = async (c) => {
    setAsking(null)
    await onRemove(c)
  }

  const previewCols = [
    ...courts.map((c) => ({ key: c.id, name: c.name, style: courtStyle(c.id) })),
    { key: 'none', name: courts.length ? 'Uten hall' : 'Utleie', style: NO_COURT_STYLE }
  ]

  return (
    <div className="rt-courts">
      <section className="card rt-courts-card" aria-labelledby="rt-hb-h">
        <div className="section-head-text">
          <h2 id="rt-hb-h" className="section-title">Haller og baner</h2>
          <p className="section-sub">Haller vises som egne kolonner i dagvisningen, og kan velges på hver utleie.</p>
        </div>

        {courts.length === 0 ? (
          <EmptyState icon={LayoutGrid} compact title="Ingen haller ennå." />
        ) : (
          <ul className="list rt-court-list">
            {courts.map((c) => (
              <li key={c.id} className="rt-court-item">
                <div className="rt-court-row">
                  <Swatch style={courtStyle(c.id)} size={18} />
                  <span className="rt-court-name">
                    {c.name}
                    {c.floor ? <span className="muted rt-court-floor"> · {c.floor}</span> : null}
                  </span>
                  <IconButton icon={Trash2} label={`Fjern ${c.name}`} danger iconSize={16} onClick={() => setAsking(c.id)} />
                </div>
                {asking === c.id && (
                  <InlineConfirm
                    label="Bekreft fjerning"
                    message={`Fjerne «${c.name}»? Eksisterende utleier beholdes.`}
                    confirmLabel="Fjern"
                    onConfirm={() => confirmRemove(c)}
                    onCancel={() => setAsking(null)}
                  />
                )}
              </li>
            ))}
          </ul>
        )}

        <form className="rt-court-form" onSubmit={onAdd}>
          <label className="rt-court-input">
            <span className="sr-only">Navn på ny hall</span>
            <input
              className="input"
              placeholder="F.eks. Hall A, Bane 2, PT-rom"
              value={courtName}
              onChange={(e) => setCourtName(e.target.value)}
              maxLength={100}
            />
          </label>
          <Button type="submit" variant="primary" icon={Plus} disabled={!courtName.trim()}>Legg til</Button>
        </form>
      </section>

      <section className="card rt-courts-card" aria-labelledby="rt-dv-h">
        <div className="row-between">
          <h2 id="rt-dv-h" className="h3">Slik ser dagvisningen ut</h2>
          <span className="muted rt-small">Én kolonne per hall</span>
        </div>
        <div className="rt-preview-scroll">
          <div className="rt-preview" style={{ gridTemplateColumns: `repeat(${previewCols.length}, minmax(84px, 1fr))` }}>
            {previewCols.map((c) => (
              <div key={c.key} className="rt-preview-col">
                <span className="rt-preview-head"><Swatch style={c.style} size={10} />{c.name}</span>
                <span className="rt-preview-block" style={{ background: c.style.bg, color: c.style.fg, borderColor: c.style.bd }}>
                  {c.name}
                </span>
              </div>
            ))}
          </div>
        </div>
        <span className="muted rt-small">Utleier uten hall havner i kolonnen «Uten hall».</span>
      </section>
    </div>
  )
}

export default CourtsTab
